import React from 'react'
import { List } from '@mui/material';
import Item from '../Item/Item'
import '../ListItems/ListItems.css'
function ListKeyWords({keyWords, removeTest}) {
  return (
    
    <List className='package-name'>
      {
        keyWords.map((key,index) => {
            return (
              <Item 
              key={index}
              className='package-name-child'
              id={key}
              test={key}
              removeTest={removeTest}
              />
            );
        })
      }
    </List>
  
  )
}

export default ListKeyWords